<template>
  <div>
    <!--顶部标题菜单-->
    <div class = "header">
      <p class = "h_title">{{txtLang[curLang]['guessOrder']}}</p>
      <a @click = "back" href = "javascript:void(0)" class = "h_btn" ></a>
    </div>

    <LoadingBox v-show = "loadSH"/> 

    <div class = "nav">
      <ul>
        <li @click = "tab(0)" :class = "tabIndex == 0 ? 'on' : ''">
          <div class = "flex flex-align-center">
            <p>{{txtLang[curLang].all}}</p>
          </div>
        </li>
        <li class = "flex flex-align-center" @click = "tab(1)" :class = "tabIndex == 1 ? 'on' : ''">
          <div class = "flex flex-align-center">
            <p>{{txtLang[curLang].hasReward}}</p>
          </div>
        </li>
        <li class = "flex flex-align-center" @click = "tab(2)" :class = "tabIndex == 2 ? 'on' : ''">
          <div class = "flex flex-align-center">
            <p>{{txtLang[curLang].rewarding}}</p>
          </div>
        </li>
        <li class = "flex flex-align-center" @click = "tab(3)" :class = "tabIndex == 3 ? 'on' : ''">
          <div class = "flex flex-align-center">
            <p>{{txtLang[curLang].hasCancel}}</p>
          </div>
        </li>
      </ul>
    </div>

    <div class = "list">
      <None v-if = "list.length == 0" :noData="txtLang[langName]['noData']"/> 
      <ul class = "listBox" v-else>
        <li v-for = "v,index in list" @click = "toDetail(v.order_id)">
          <div class = "l_top">
            <span class = "lt_r">{{dateStrPower(v.datetime,0)}}</span>
            <span class = "lt_handicap">{{txtLang[curLang]['playType'][v.play_type_id]}}</span>
            <span class = "lt_spe">{{txtLang[curLang]['playOption'][v.play_type_id][v.play_type_option_id - 1]}} {{v.play_type_option_odds}}</span>
          </div>
          <div class = "l_txt">
            <span class = "grey"><span class = "lt_name">{{v.home_team_name}}</span> {{v.game_status == 2 ? v.home_team_scope + ':' + v.away_team_scope : 'VS'}} <span class = "lt_name">{{v.away_team_name}}</span></span>
            <span class = "blue" v-if = "v.play_type_id != 1">({{oddsT(v.handicap,v.play_type_id)}})</span>
          </div>
          <div class = "l_result">
            <span class = "lr_r flex flex-align-center">
              <span class= "lrr_1" v-if = "v.result_status == 0">{{txtLang[curLang].rewarding}}</span>
              <span class= "lrr_2" v-if = "v.result_status == 1" v-html = "txtLang[curLang].winCoin(moneyStr(v.user_get_coin))"></span>
              <span class= "lrr_2" v-if = "v.result_status >= 4">{{txtLang[curLang].returnAll}}</span>
              <span class= "lrr_3" v-if = "v.result_status >= 4">{{txtLang[curLang].hasCancel}}</span>
              <span class= "lrr_4" v-if = "v.result_status == 1">W</span>
              <span class= "lrr_5" v-if = "v.result_status == 2">L</span>
              <span class= "lrr_6" v-if = "v.result_status == 3">P</span>
            </span>
            <div class = "lr_l">
              <span class = "lrl_name">{{txtLang[curLang].bet}}</span>
              <span class = "lrl_input">{{moneyStr(v.coin)}}</span>
            </div>
          </div>
        </li>
      </ul>
      <div class = "btnBox" v-if = "list.length > 0 && next">
        <a @click = "nextPage" href = "javascript:void(0);">{{txtLang[curLang]['moreGuessHistory']}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import None from './common/None'
import LoadingBox from './common/Loading'

export default {
  name: 'HelloWorld',
  components:{
    None,
    LoadingBox
  },
  data () {
    return {
      loadSH:true,
      tabIndex:0,
      //list:[{"order_id":"202001171428567419940918","home_team_name":"Hansa Rostock","home_team_scope":0,"away_team_name":"Lyngby","away_team_scope":0,"play_type_id":1,"play_type_option_id":"1","play_type_option_odds":2.18,"coin":100,"handicap":0,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579242536},{"order_id":"202001171428568540429821","home_team_name":"Hansa Rostock","home_team_scope":0,"away_team_name":"Lyngby","away_team_scope":0,"play_type_id":3,"play_type_option_id":"2","play_type_option_odds":0.81,"coin":100,"handicap":3,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579242536},{"order_id":"202001171428563849198316","home_team_name":"St.Polten","home_team_scope":0,"away_team_name":"SV Horn","away_team_scope":0,"play_type_id":2,"play_type_option_id":"1","play_type_option_odds":1.03,"coin":100,"handicap":-1.25,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579242536},{"order_id":"202001171415455954450530","home_team_name":"Burnley","home_team_scope":0,"away_team_name":"Leicester City","away_team_scope":0,"play_type_id":1,"play_type_option_id":"1","play_type_option_odds":16,"coin":100,"handicap":0,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579241745},{"order_id":"202001171059463894026921","home_team_name":"Adelaide United","home_team_scope":1,"away_team_name":"Melbourne Victory FC","away_team_scope":0,"play_type_id":1,"play_type_option_id":"2","play_type_option_odds":3.3,"coin":100,"handicap":0,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579229986},{"order_id":"202001171040465071474143","home_team_name":"Menemen Belediye Spor","home_team_scope":0,"away_team_name":"Giresunspor","away_team_scope":0,"play_type_id":1,"play_type_option_id":"3","play_type_option_odds":3.2,"coin":100,"handicap":0,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579228846},{"order_id":"202001171037562065745927","home_team_name":"FC Juarez","home_team_scope":4,"away_team_name":"Pumas UNAM","away_team_scope":4,"play_type_id":3,"play_type_option_id":"1","play_type_option_odds":1.05,"coin":100,"handicap":2.25,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579228676},{"order_id":"202001171020005121262263","home_team_name":"FC Juarez","home_team_scope":4,"away_team_name":"Pumas UNAM","away_team_scope":4,"play_type_id":2,"play_type_option_id":"1","play_type_option_odds":0.98,"coin":100,"handicap":0,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579227600},{"order_id":"202001170925112676633828","home_team_name":"Adelaide United","home_team_scope":1,"away_team_name":"Melbourne Victory FC","away_team_scope":0,"play_type_id":2,"play_type_option_id":"1","play_type_option_odds":0.85,"coin":100,"handicap":-0.5,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579224311},{"order_id":"202001170925115335280439","home_team_name":"Adelaide United","home_team_scope":1,"away_team_name":"Melbourne Victory FC","away_team_scope":0,"play_type_id":3,"play_type_option_id":"1","play_type_option_odds":1.06,"coin":100,"handicap":3.25,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579224311}],
      list:[],
      page:1,
      next:false,
    }
  },
  methods: {
    toDetail(id){
      this.$router.push({name:'guessOrderDetail',query:{id:id}})
    },
    back(){
      this.$router.back(-1)
    },
    nextPage(){
      this.page++;
      var _this = this;
      setTimeout(_this.getList,10);
    },
    tab(index){
      this.tabIndex = index;
      this.page = 1;
      var _this = this;
      setTimeout(_this.getList,10);
    },
  	getList(){
      var statusArr = [0,2,1,3];
      var token = localStorage.getItem('guess_token') == null ? '' : '&token=' + localStorage.getItem('guess_token');
      this.loadSH = true;

      this.axios.get(this.getHost() + '/orders/list?lan=' + this.langIndex + '&status=' + statusArr[this.tabIndex] + '&page=' + this.page + token).then(
          (response)=>{
          var re = response.data;
          if(re.code == 200){
            //读取联赛列表数据，默认全不选
            this.loadSH = false;
            if(this.page == 1){
              this.list = re.data.list;
            }
            else{
              this.list = this.list.concat(re.data.list);
            }
            
            this.next = re.data.next;
          }
          else if(re.code == 401){
            this.gotoLogin();
          }
          else{
            alert(re.message);
          }
      }).catch((response)=>{
        console.log(response);
      });
    },
  },
  created(){
  	//控制台查看变量
    window.vueVar = this;
    var that = this;
    //this.delStorage('guess_token');
    this.isUserLogin({
        source: this.source[this.curLang],
        platform: 2,
        success: function(data){
            if(data == 1){
                that.getList();
            }else{
                //that.isLoadingShow = false;
                that.gotoLogin();
                return;
            }
        }
    });
  }
}
</script>

<style scoped>
/*头部*/
.header{z-index:100;position:fixed;top:0;left:0;width:100%;height:120px;background:#232048}
.header .h_title{font-size:40px;color:#fff;line-height:120px;text-align:center}
.header .h_btn{width:120px;height:120px;position:absolute;top:0;left:0}
.header .h_btn:after{display:block;content:'';width:24px;height:24px;margin-top:-12px;margin-left:-12px;border-top:4px solid #fff;border-left:4px solid #fff;position:absolute;top:50%;left:50%;transform:rotate(-45deg);-webkit-transform:rotate(-45deg);-moz-transform:rotate(-45deg);-ms-transform:rotate(-45deg);-o-transform:rotate(-45deg);}

.nav{position:fixed;z-index:100;top:120px;left:0;width:100%;background:#171531}
.nav ul{background:#232048;border-radius:16px;font-size:0;margin:40px 22px;}
.nav ul li{width:25%;box-sizing:border-box;border-right:2px solid #171531;display:inline-block;vertical-align:top;text-align:center;height:76px;}
.nav ul li:last-child{border-right:none}
.nav ul li div{height:76px;}
.nav ul li p{line-height:38px;color:#fff;font-size:30px;margin:0 auto}
.nav ul li.on p{color:#00ecfd}

.list{padding:276px 22px 50px;}
.list .listBox li{background:#3b3860;height:160px;border-radius:16px;margin-bottom:20px;padding:0 32px}
.list .listBox .l_top{padding-top:20px;padding-bottom:4px}
.list .listBox .l_top span{font-size:24px;color:#00ecfd;display:inline-block;vertical-align:middle}
.list .listBox .l_top .lt_r{float:right;font-size:20px;color:#bbbabf}
.list .listBox .l_top .lt_handicap{margin-right:10px;font-size:14px;color:#bbbabf;border:2px solid #bbbabf;background:#4f4c70;border-radius:200px;min-width:100px;text-align:center}
.list .listBox .l_top .lt_spe{font-weight:bolder;white-space:nowrap}
.list .listBox .l_txt{font-size:0;padding-bottom:10px}
.list .listBox .l_txt span{display:inline-block;vertical-align:top;font-size:20px;color:#bbbabf;}
.list .listBox .l_txt .grey{color:#bbbabf;}
.list .listBox .l_txt .blue{color:#6371ea;margin-left:6px}
.list .listBox .l_txt .lt_name{max-width:240px;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;}
.list .listBox .l_result{}
.list .listBox .l_result .lr_r{float:right;height:48px;}
.list .listBox .l_result .lr_r span{margin-left:12px}
.list .listBox .l_result .lr_r .lrr_1{color:#fff;background:#626080;border-radius:6px;padding:0 8px}
.list .listBox .l_result .lr_r .lrr_2{color:#fd7446;}
.list .listBox .l_result .lr_r .lrr_2 b{font-size:24px}
.list .listBox .l_result .lr_r .lrr_3{color:#3b3860;background:#626080;border-radius:6px;padding:0 8px}
.list .listBox .l_result .lr_r .lrr_4{color:rgba(255,255,255,0.7);font-size:24px;border-radius:200px;width:40px;height:40px;background:#e74f6b;text-align:center;line-height:40px}
.list .listBox .l_result .lr_r .lrr_5{color:rgba(255,255,255,0.7);font-size:24px;border-radius:200px;width:40px;height:40px;background:#00d9cd;text-align:center;line-height:40px}
.list .listBox .l_result .lr_r .lrr_6{color:rgba(255,255,255,0.7);font-size:24px;border-radius:200px;width:40px;height:40px;background:#5d8ef9;text-align:center;line-height:40px}

.list .listBox .l_result .lr_l{height:48px;line-height:48px;font-size:0}
.list .listBox .l_result .lr_l span{display:inline-block;vertical-align:middle;}
.list .listBox .l_result .lr_l .lrl_name{color:#bbbabf;font-size:20px;margin-right:16px}
.list .listBox .l_result .lr_l .lrl_input{font-size:24px;color:#fff;height:48px;background:#232048;border-radius:24px;padding:0 24px;width:110px}
.list .btnBox{}
.list .btnBox a{display:block;font-size:36px;color:#6371ea;text-align:center;height:106px;line-height:106px}
</style>








// WEBPACK FOOTER //
// src/components/guessOrder.vue